
import React, { Component } from "react";
import ChatWindow from "./ChatWindow";
import styles from "./chatStyle";
import { withStyles } from "@material-ui/core/styles";
import { withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { inject } from "mobx-react";
import Header from "./common/Header";
import {
  Close as CloseButton,
  Message as CannedMessageButton,
  MultipleChoice as ShowChoiceButton,
} from "./common/Buttons";
import { v4 as uuidv4 } from "uuid";
import {
  postData,
  getDataWithQueryString,
} from "../../../../api/componentAPIs"
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import Events from "../../../../utilities/EventEmitter"
import { WithChatWindow } from "./common";

@inject("DispatchStore")
class ChatContainer extends Component {
  constructor() {
    super();
    this.state = {
      openCannedMessages: false,
      messageList: [],
      driver: null,
      loadingMessages: false,
      openChoiceMessages: false,
      isChoiceMessageDisabled: false,
    };
  }

  componentDidMount() {
    this.fetchInfo(this.props.driverId);
    Events.on("DispatcherMessageRead", this.markDispatcherMessageAsRead);
    Events.on("MessageFromDriver", this.onMessageFromDriver);
  }

  componentWillUnmount() {
    Events.off("DispatcherMessageRead", this.markDispatcherMessageAsRead);
    Events.off("MessageFromDriver", this.onMessageFromDriver);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.driverId !== this.props.driverId) {
      this.setState({
        openCannedMessages: false,
      });
      this.fetchInfo(this.props.driverId);
    }
  }

  disableChoiceMessageIcon = (isDisabled) => {
    this.setState({
      isChoiceMessageDisabled: isDisabled,
    })
  }

  fetchInfo = (driverId) => {
    const driver = this.props.DispatchStore.getCurrentDriver(driverId);
    this.setState({
      driver: driver,
      loadingMessages: true,
      messageList: [],
      unReadCount: driver.unReadCount
    });

    getDataWithQueryString(
      "GetAllMessages",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&driverId=${driverId}`,
    ).then((response) => {
      if (response && response.status === 200) {
        const data = response.data;
        const remove = [];
        const mapParentMessage = data.map((element, index) => {
          if (element.parentMessageId) {
            const matchmsg = data.findIndex(
              (msg) => element.parentMessageId === msg.messageId,
            );
            if (matchmsg !== -1) {
              element["parentMessage"] = data[matchmsg];
              element["type"] = "text";
              remove.push(matchmsg);
              return element;
            }
          } else {
            element["parentMessage"] = {};
            element["type"] = "text";
            return element;
          }
        });
        remove.forEach((ele) => {
          delete mapParentMessage[ele];
        });
        const removeNullValue = mapParentMessage.filter(function (el) {
          return el != null;
        });
        removeNullValue.sort(function (a, b) {
          return new Date(a.messageDateTs) - new Date(b.messageDateTs);
        });
        this.setState(
          {
            loadingMessages: false,
            messageList: removeNullValue,
            // unReadCount: JSON.parse(JSON.stringify(props.routeData))
            //   .unReadCount,
          },
          () => {
            this.markAllDriverMessageAsRead();
          },
        );
      }
    });
  };

  markDispatcherMessageAsRead = (dispatchMessageString) => {
    if (this.state.messageList.length) {
      const dispatchMessage = JSON.parse(dispatchMessageString);
      let isMessageMarked = false;
      const updatedMessageList = this.state.messageList.map((message) => {
        if (
          message.messageId.toUpperCase() ===
          dispatchMessage.messageId.toUpperCase()
        ) {
          message.isRead = true;
          isMessageMarked = true;
        }
        return message;
      });
      if (isMessageMarked) {
        this.setState({
          messageList: updatedMessageList,
        });
      }
    }
  };

  markAllDriverMessageAsRead = () => {
    const onChatDriverId = this.state.driver?.driverId;
    this.props.DispatchStore.clearDriverUnreadCount(onChatDriverId);
    this.props.DispatchStore.updateNotificationReadStatus(onChatDriverId);
    this.state.messageList.forEach((message) => {
      if (message.sender.toUpperCase() === onChatDriverId.toUpperCase() && !message.isRead) {
        this.markDriverMessageAsRead(message);
      }
    });
  };

  sendMessage = (messageInfo) => {
    const {
      message,
      isUrgent = false,
      choice = [],
      parentMessageId,
      metadata,
    } = messageInfo;
    const inputObj = {
      terminalCode: this.props.userData.userProfile.terminal.code,
      driverId: this.state.driver?.driverId,
      text: message,
      eventDateTime: new Date(),
      urgent: isUrgent,
      choice,
      messageId: uuidv4().toUpperCase(),
      parentMessageId: parentMessageId || null,
      userId: this.props.userData.userProfile.userId,
      metadata,
    };
    messageInfo["messageId"] = inputObj.messageId;
    postData("MessageToDriver", inputObj).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        const messageList = [...this.state.messageList, messageInfo];
        const newMessageList = messageList
          .map((msg) => {
            if (msg.messageId !== parentMessageId) {
              return msg;
            }
          })
          .filter(function (el) {
            return el != null;
          });
        this.markAllDriverMessageAsRead();
        this.setState({
          messageList: newMessageList,
          unReadCount: 0,
          isChoiceMessageDisabled: false,
        });
      }
    });
  };

  onMessageFromDriver = (driverMessageString) => {
    const onChatDriverId = this.state.driver?.driverId;
    const driverMessage = JSON.parse(driverMessageString);
    const matchRoute = this.props.DispatchStore.currentActiveRoutes.find(
      (route) =>
        route.driverId.toUpperCase() === driverMessage.sender.toUpperCase(),
    );
    if (matchRoute && driverMessage.message.length > 0) {
      if (matchRoute.driverId === onChatDriverId) {
        if (driverMessage.parentMessageId) {
          const matchmsg = this.state.messageList.findIndex(
            (msg) =>
              driverMessage.parentMessageId.toUpperCase() ===
              msg.messageId.toUpperCase(),
          );
          if (matchmsg !== -1) {
            const newMessageList = this.formateMessageList(driverMessage);
            this.setState(prevState => ({
              ...prevState,
              messageList: [
                ...newMessageList,
                {
                  type: "text",
                  parentMessage: prevState.messageList[matchmsg],
                  ...driverMessage,
                },
              ],
              unReadCount: prevState.unReadCount + 1,
            }));
          }
        } else {
          this.setState(prevState => ({
            ...prevState,
            messageList: [
              ...prevState.messageList,
              {
                type: "text",
                parentMessage: {},
                ...driverMessage,
              },
            ],
            unReadCount: prevState.unReadCount + 1,
          }));
        }
        this.markDriverMessageAsRead(driverMessage);
        this.props.DispatchStore.updateNotificationReadStatus(onChatDriverId);
      }
    }
  };

  markDriverMessageAsRead = (message) => {
    const requestObj = {
      terminalCode: this.props.userData.userProfile.terminal.code,
      driverId: message.sender,
      messageId: message.messageId,
      eventDateTime: new Date(),
      userId: this.props.userData.userProfile.userId,
    };

    postData("DispatcherReadReceipt", requestObj).then((response) => {
      if (Math.trunc(response.status / 100) === 2) {
        const updatedMessageList = this.state.messageList.map((msg) => {
          if (msg.messageId.toUpperCase() === message.messageId.toUpperCase()) {
            msg.isRead = true;
          }
          return msg;
        });
        this.setState({
          messageList: updatedMessageList,
        });
      }
    });
  };

  formateMessageList = (driverMessage) => {
    return this.state.messageList
      .map((msg) => {
        if (msg.messageId !== driverMessage.parentMessageId) {
          return msg;
        }
      })
      .filter(function (el) {
        return el != null;
      });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.mute) {
      return;
    }
  }

  handleCannedMessageClick = (showCannedMessages) => {
    this.setState({
      openCannedMessages: showCannedMessages,
    });
  };

  handleChoiceMessageClick = (showChoiceMessages) => {
    this.setState({
      openChoiceMessages: showChoiceMessages,
    });
  };

  handleChatWindowClose = () => {
    this.markAllDriverMessageAsRead();
    this.props.onClose();
  }

  render() {
    const { classes } = this.props;
    const { loadingMessages, unReadCount } = this.state;
    const pendingCustomers =
      this.props.DispatchStore.getDriverDetails(
        this.state.driver?.driverId,
      )?.pendingStops.map((stop) => stop.name) ?? [];
    return (
      <>
        <Header title={this.state.driver?.driverName}>
          <ShowChoiceButton
            isDisabled = {this.state.isChoiceMessageDisabled}
            onClick={() => this.handleChoiceMessageClick(true)}
          />
          <CannedMessageButton onClick={() => this.handleCannedMessageClick(true)} />
          <CloseButton onClick={this.handleChatWindowClose} />
        </Header>
        <ChatWindow
          loadingMessages={loadingMessages}
          messageList={this.state.messageList}
          onUserInputSubmit={this.sendMessage}
          driverInfo={{
            pendingCustomers,
            name: this.state.driver?.driverName,
            unReadCount: unReadCount,
            metadataColor: this.state.driver?.color,
          }}
          classes={classes}
          openCannedMessages={this.state.openCannedMessages}
          handleCannedMessageClick={this.handleCannedMessageClick}
          openChoiceMessages={this.state.openChoiceMessages}
          disableChoiceMessageIcon = {this.disableChoiceMessageIcon}
          handleChoiceMessageClick={this.handleChoiceMessageClick}
        />
      </>
    );
  }
}


export default compose(
  withTheme(),
  withStyles(styles),
  withUserProfile,
  WithChatWindow,
)(ChatContainer);
